import type { MaybeRefOrGetter, Ref } from "vue";

import { computed, toValue } from "vue";

import type { ValidationRuleHydrated } from "@/lib/validation/validation.types.ts";

function useValidationState({
  errorLabel,
  allRules,
  modelValue,
}: {
  allRules: Ref<ValidationRuleHydrated[]>;
  errorLabel: Ref<string>;
  modelValue: MaybeRefOrGetter<unknown>;
}) {
  const isValidating = computed(() =>
    allRules.value.some(({ isValidating }) => isValidating.value),
  );

  const failedRule = computed(() => {
    return allRules.value.find(({ isVisible }) => isVisible.value) ?? null;
  });

  const error = computed(() => {
    if (!failedRule.value) {
      return null;
    }
    return (
      failedRule.value.message(errorLabel.value, toValue(modelValue)) ||
      failedRule.value.name
    );
  });

  const blockingRules = computed(() => {
    return allRules.value.filter(({ blocking }) => blocking);
  });
  const blockingRulesValid = computed(() => {
    return blockingRules.value.every(({ isValid }) => isValid.value);
  });

  const allRulesValid = computed(() => {
    return allRules.value.every(({ isValid }) => isValid.value);
  });

  return {
    allRulesValid,
    blockingRulesValid,
    error,
    failedRule,
    isValidating,
  };
}

export { useValidationState };
